import { gql } from '@apollo/client';

export const GET_QC_PENALTY_UPLOAD_TASKS = gql`
  query GetQcPenaltyUploadTasks {
    getQcPenaltyUploadTasks {
      id
      submitterName
      sourceFileName
      resultFileName
      periodStart
      periodEnd
      rowCount
      successCount
      failCount
      status
      failureReason
      createdAt
      completedAt
    }
  }
`;

export const GET_QC_PENALTY_TASK_RELATED_BILL_IDS = gql`
  query GetQcPenaltyTaskRelatedBillIds($taskId: Long!) {
    getQcPenaltyTaskRelatedBillIds(taskId: $taskId)
  }
`;
